export default __webpack_public_path__ + "static/media/mathspic1.cd42c238.jpeg";